import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  total: 0,
};

const coursesSlice = createSlice({
  name: "courses",
  initialState,
  reducers: {
    clearCourses: () => {
      return initialState;
    },

    refreshAndSetCourses: (state, action) => {
      return { ...action.payload };
    },

    mergeCourses: (state, action) => {
      return { data: action.payload.data, total: action.payload.total };
    },

    pushCourse: (state, action) => {
      return {
        data: [...state.data, action.payload],
        total: state.total + 1,
      };
    },
  },
});

export const { refreshAndSetCourses, mergeCourses, clearCourses, pushCourse } =
  coursesSlice.actions;
export default coursesSlice.reducer; 